module.exports = __webpack_public_path__ + "img/customer_group.7f8f5aee.svg";